import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProgramSections from "./components/ProgramSections";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";
import StickyMobileCta from "./components/StickyMobileCta";

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main id="main-content">
        <Hero />
        <ProgramSections />
        <FinalCta />
      </main>
      <Footer />
      <StickyMobileCta />
    </div>
  );
};

export default App;
